export enum Status {
  IN_PROGRESS = 'in-progress',
  NOT_PASS = 'not-pass',
  PASS = 'pass',
}

export enum Role {
  CREATOR = 'CREATOR',
  APPROVER = 'APPROVER',
  NONE = 'NONE',
}

export enum ReportType {
  RANGE = 'RANGE',
  SINGLE = 'SINGLE',
}
